import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dynamic-breadcrumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
  })
export class BreadcrumbComponent implements OnInit {
  @Input() bgColor: string = 'transparent';
  @Input() fontSize: string = '14px';
  @Input() lastLinkColor: string = 'rgba(196, 196, 205, 0.42)';
  @Input() fontColor: string = '#c4c4cd';
  items: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.items = this.buildBreadCrumb(this.route.root);
    });
  }

  ngOnInit(): void {}

  buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: any[] = []): any[] {
    let children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (let child of children) {
      if (child.routeConfig && child.routeConfig.data && child.routeConfig.data['breadcrumb']) {
        const bc = child.routeConfig.data['breadcrumb'];
        if (Array.isArray(bc)) {
          bc.forEach(crumb => {
            breadcrumbs.push({
              label: crumb.label,
              routerLink: crumb.url ? [crumb.url] : null
            });
          });
        }
      }
      return this.buildBreadCrumb(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }
}